import React, {useCallback, useEffect, useState} from 'react';
import {
  RefreshControl,
  View,
  ScrollView,
  Animated,
  DeviceEventEmitter,
} from 'react-native';
import {BasicObject, SafeAny} from '@types';
import theme from '@style';
import {getBannerList, getNoticeCheck, getGoldAreaList} from './home.service';
// import {envConfig} from '@/utils';
import globalStore from '@services/global.state';
import HomeMenu from './components/home-menu';
import HomeHeader from './components/home-header';
import Download from './components/download';
import HomeBanner from './components/home-banner';
import {BannerListItem, HomeGameFloorItem} from './home.type';
import {debounce, setDataForSettled} from '@/utils';

import {useFocusEffect} from '@react-navigation/native';
// import {NoMoreData} from '@basicComponents/default-page';
import Spin from '@basicComponents/spin';
import Drawer, {DrawerRef} from '@basicComponents/drawer/drawer';
import HomeSide from './components/home-side';
import {useToChat} from '@/pages/home/im.hook';
import {sequentialStorage} from '@utils/Storage/SequentialStorage';
import HomeV2 from './v2/home';

const Home = () => {
  const menuRef = React.useRef<DrawerRef>(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const setMenuOpen = (bool: boolean, _unreadCount?: number) => {
    if (bool) {
      setUnreadCount(_unreadCount || 0);
      menuRef.current?.open();
    } else {
      menuRef.current?.close();
    }
  };
  const [noticeMap, setNoticeMap] = useState<BasicObject>({
    FREE_LOTTERY: 0,
    REBATE: 0,
    LUCKY_SPIN: 0,
  });
  const [homeGames] = useState<HomeGameFloorItem[]>([]);
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [bannerList, setbannerList] = React.useState<BannerListItem[]>([]);
  const [pageLoading, setPageLoading] = React.useState(false);
  const [version, setVersion] = useState(0);
  // const [setActiveTab] = useState(0);
  const [imgs, setImgs] = useState({} as {[key: string]: string});
  const topHeight = React.useRef(0);
  const [currentScrollY, setCurrentScrollY] = useState(0);

  const getImgs = () => {
    getGoldAreaList('SUSPENSION_APP')
      .then(r => {
        /**
         * {
         * "IM_APP":
         * CUSTOMER_SERVICE
         * }
         */
        setImgs(
          r.reduce((pre, cur) => {
            // 存贮im图标
            if (cur.moduleType === 'IM_APP') {
              globalStore.imIcon = cur.defaultImgUrl;
            }
            (pre as SafeAny)[cur.moduleType] = cur.defaultImgUrl;
            return pre;
          }, {}),
        );
      })
      .catch(e => console.log('e', e));
  };
  const getList = (refresh: boolean = false) => {
    if (!refresh) {
      setPageLoading(true);
    }
    Promise.allSettled([getBannerList(2)])
      .then(([banner]) => {
        setDataForSettled(setbannerList, banner);
      })
      .finally(() => {
        if (!refresh) {
          DeviceEventEmitter.emit('startDownload');
        }
        setPageLoading(false);
        setRefreshing(false);
      });
  };
  const doNotice = (token: string | null) => {
    if (token) {
      getNoticeCheck().then(noticeList => {
        const newNoticeMap: BasicObject = {};
        Object.keys(noticeMap).forEach(key => {
          const notice = noticeList.find(item => item.noticeKey === key);
          if (notice) {
            newNoticeMap[key] = notice.noticeCount;
          }
        });
        setNoticeMap(newNoticeMap);
      });
    } else {
      setNoticeMap({
        FREE_LOTTERY: 0,
        REBATE: 0,
        LUCKY_SPIN: 0,
      });
    }
  };

  useEffect(() => {
    getImgs();
    getList();
    // scrollAnim.addListener(e => {
    //   handleScroll(e);
    // });
    return () => {
      setRefreshing(false);
      scrollAnim.removeAllListeners();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFocusEffect = useCallback(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      doNotice(token);
      globalStore.amountCheckOut.next({});
      if (token) {
        globalStore.refreshNotification.next();
      }
    });
    return () => {
      sub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useFocusEffect(handleFocusEffect);
  const scrollViewRef = React.useRef<ScrollView>(null);
  const scrollAnim = React.useRef(new Animated.Value(0)).current;
  const measures = React.useRef<number[]>([]);

  const handleScroll = (y: number) => {
    const totalTop = topHeight.current + 0;
    if (!totalTop) {
      return;
    }
    for (let i = homeGames.length; i >= 0; i--) {
      if (y >= totalTop + getToTopHeight(i)) {
        // setActiveTab(i);
        break;
      }
    }
    setCurrentScrollY(y);
  };

  const handleScrollTo = debounce((y: number) => {
    handleScroll(y);
  }, 50);

  const getToTopHeight = (index: number) => {
    return measures.current
      .slice(0, index)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  };

  useToChat();
  useFocusEffect(
    useCallback(() => {
      sequentialStorage.emit('updated');
    }, []),
  );
  return (
    <Spin loading={pageLoading} style={[theme.flex.col, theme.fill.fill]}>
      <View
        style={[
          theme.fill.fill,
          theme.flex.col,
          theme.background.lightGrey,
          theme.position.rel,
        ]}>
        <HomeHeader setMenuOpen={setMenuOpen} version={version} />
        {globalStore.isWeb ? <Download /> : null}
        <Animated.ScrollView
          ref={scrollViewRef}
          onScroll={e => {
            handleScrollTo(e.nativeEvent.contentOffset.y);
          }}
          style={[theme.flex.flex1]}
          stickyHeaderIndices={[1]}
          refreshControl={
            <RefreshControl
              refreshing={refreshing}
              onRefresh={() => {
                setRefreshing(true);
                getList(true);
                doNotice(globalStore.token);
                setVersion(v => v + 1);
              }}
            />
          }>
          <View
            onLayout={e => {
              topHeight.current = e.nativeEvent.layout.height;
            }}>
            <HomeBanner bannerList={bannerList} />
            <HomeV2 scrollViewRef={scrollViewRef} scrollY={currentScrollY} />
          </View>
          {/* <NoMoreData text="" /> */}
        </Animated.ScrollView>
        <HomeSide hasService={!!imgs.CUSTOMER_SERVICE} chatImg={imgs.IM_APP} />
      </View>
      <Drawer ref={menuRef}>
        <HomeMenu setMenuOpen={setMenuOpen} unreadCount={unreadCount} />
      </Drawer>
    </Spin>
  );
};

export default Home;
